

module.exports = {
	GRAPHQL_URL: process.env.REACT_APP_GRAPHQL,
	WEBAPPS_PUBLISH_STATUS: process.env.REACT_APP_WEBAPPS_PUBLISH_STATUS,
	CLIENT_FIREBASE_API_KEY: "YOUR_API_KEY",
  	CLIENT_FIREBASE_AUTH_DOMAIN: "YOUR_AUTH_DOMAIN",
	SIGNUP_FIREBASE_APP_ID: process.env.REACT_APP_SIGNUP_FIREBASE_APP_ID,
	SIGNUP_FIREBASE_API_KEY: process.env.REACT_APP_SIGNUP_FIREBASE_API_KEY,
	SIGNUP_FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_SIGNUP_FIREBASE_AUTH_DOMAIN,
	SIGNUP_FIREBASE_PROJECT_ID: process.env.REACT_APP_SIGNUP_FIREBASE_PROJECT_ID,
	SIGNUP_FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_SIGNUP_FIREBASE_STORAGE_BUCKET,
	SIGNUP_FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_SIGNUP_FIREBASE_MESSAGING_SENDER_ID,
	
}

//"https://graphql-flowster.onrender.com/"